import { ParsedCsvRow } from '~/app/components/knowledgeBase/componentSchemaManager/ComponentSchemaManager.types';

export function convertRowsToCsv(rows: ParsedCsvRow[]): string {
  if (rows.length === 0) return '';

  const headers = rows.reduce<string[]>((accumulator, row) => {
    Object.keys(row).forEach((key) => {
      if (!accumulator.includes(key)) {
        accumulator.push(key);
      }
    });

    return accumulator;
  }, []);

  const content = rows.map((row) =>
    headers
      .map((h) => {
        const val = row[h] || '';
        return `"${String(val).replace(/"/g, '""')}"`;
      })
      .join(','),
  );
  return [headers.join(','), ...content].join('\n');
}

export function createCsvFileFromRows(
  rows: ParsedCsvRow[],
  fileName: string,
): File {
  return new File([convertRowsToCsv(rows)], fileName, {
    type: 'text/csv',
  });
}
